import Header from './components/Header';
import Hero from './components/Hero';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import IndexSection from './components/IndexSection';
import TopicsSection from './components/TopicsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <RankingSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
        <FAQSection />
        <AppSection />
        <ContactSection />
        <AboutSection />
        <CardsSection />
        <MediaSection />
        <CarouselSection />
        <IndexSection />
        <TopicsSection />
      </main>
      <Footer />
    </div>
  );
}